import { render, staticRenderFns } from "./Flow.old.vue?vue&type=template&id=76bedd22"
import script from "./Flow.old.vue?vue&type=script&lang=js"
export * from "./Flow.old.vue?vue&type=script&lang=js"
import style0 from "./Flow.old.vue?vue&type=style&index=0&id=76bedd22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports